<template>
  <label class="c-checkbox__label">
    <input
      type="checkbox"
      class="c-checkbox"
      :checked="item.checked"
      :value="item.value"
      @change="change"
    />
    <span class="c-checkbox__visual"></span>
    <span class="c-checkbox__text">{{ item.title }}</span>
    <Infohover  :helptitle="item.helpTitle" :helptexthtml="item.helpTextHtml"></Infohover>
    <!-- <span class="c-info-hover" v-if="item.helpTitle && item.helpTextHtml">
      <button class="c-info-hover__button" @click.prevent="infoClick(true)"></button>
      <span
        :class="[{ 'c-info-hover__box--is-shown': showInfo }, 'c-info-hover__box']"
        @click.prevent
      >
        <button class="c-info-hover__close" @click.prevent="infoClick(false)">
          Luk
        </button>
        <span class="c-info-hover__text">
          <h4 class="c-info-hover__title">
            {{ item.helpTitle }}
          </h4>
          <span v-html="item.helpTextHtml"></span>
         
        </span>
      </span>
    </span> -->
    <span class="c-checkbox-list__note" v-if="item.price">
      <strong class="c-checkbox-list__price">{{ item.price }}</strong>
      {{ item.priceNote }}
    </span>


    <slot name="CheckboxItemExtraSlot" v-bind:item="item"></slot>

  </label>
</template>
<script>
// @ is an alias to /src
import Infohover from '../infohover/info-hover.vue';

export default {
  name: 'CheckboxListItem',
  data() {
    return {
      showInfo: false
    };
  },
  components: {
    Infohover
  },
  props: {
    item: Object
  },

  methods: {
    infoClick(mode) {
      this.showInfo = mode;
    },
    change(e) {
      this.$emit('childToParent', e);
    }
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
$itemHeight: 2.2rem;
$lineHeight: 1.6rem;
$padding: ($itemHeight - $lineHeight) / 2;

@import '@/assets/scss/components/checkbox.scss';
@import './info-hover';
</style>
